module.exports = __webpack_public_path__ + "static/media/pic3.48265e94.jpg";